// extracted by mini-css-extract-plugin
export default {"slide-wrap":"oULGN","pagination":"aJGBX","carousel-container":"q6OuK","carousel-swiper":"zd8q6","carousel-slide":"qq2FY","carousel-full-width":"BpMNV","carousel-center":"JkYXS"};